export * from './text-input-autocomplete.module';
export {
  TextInputAutocompleteMenuComponent
} from './text-input-autocomplete-menu.component';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/index.ts